"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetWithSelectors = void 0;

var _normalizecssinjs = require("./normalizecssinjs");

var selectorDeclaration = function selectorDeclaration(selector, styles) {
  return "&".concat(selector, " {\n    ").concat(styles, "\n  }");
};

var selectorsAndCss = function selectorsAndCss(resets) {
  return function (selector) {
    var styles = !!resets && resets[selector];
    return !!styles ? selectorDeclaration(selector, styles) : '';
  };
};
/** Return resets of selector/s to be used with CSS-in-JS
 * @param {Object.<string, number>} resets normalize.cssinjs or similar (cssToString: true)
 * @returns {function(string\|string[]): string} selectors returns styles for given selectors
 */


var resetWithSelectors = function resetWithSelectors(resets) {
  return function (selectors) {
    var styles = !!resets ? selectorsAndCss(resets) : selectorsAndCss((0, _normalizecssinjs.normalizeCssInJs)({
      cssToString: true
    }));

    if (Array.isArray(selectors) && selectors.length > 0) {
      return "\n      ".concat(selectors.map(function (s) {
        return styles(s);
      }).join(''), "\n    ");
    }

    if (typeof selectors === 'string') {
      return styles(selectors);
    }

    return '';
  };
};

exports.resetWithSelectors = resetWithSelectors;